"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generateNewId = void 0;
var generateNewId = exports.generateNewId = function generateNewId(_ref) {
  var _ref$prefix = _ref.prefix,
    prefix = _ref$prefix === void 0 ? 'new' : _ref$prefix,
    _ref$settings = _ref.settings,
    settings = _ref$settings === void 0 ? [] : _ref$settings;
  if (!settings.find(function (item) {
    return item.id === prefix;
  })) {
    return prefix;
  }
  var counter = 1;
  // eslint-disable-next-line no-loop-func
  while (settings.find(function (item) {
    return item.id === "".concat(prefix).concat(counter);
  })) {
    counter++;
  }
  return "".concat(prefix).concat(counter);
};